<template>
  <Application>
    <b-breadcrumb :items="items" v-if="client"></b-breadcrumb>

    <b-card no-body class="p-2 mh-50">
      <div
        class="d-flex justify-content-center py-4"
        v-if="loading"
      >
        <b-spinner variant="secondary"></b-spinner>
      </div>

      <div v-else>
        <ClientProfile mode="EDIT" :data="client"/>
      </div>
    </b-card>
  </Application>
</template>

<script>
import Application from '@/components/Application/Application.vue';
import ClientProfile from '@/components/Clients/Profile.vue';
import { ClientsService } from '@/services';

export default {
  components: {
    Application,
    ClientProfile,
  },

  data() {
    return {
      loading: true,
      client: null,
    };
  },

  async created() {
    try {
      this.client = await ClientsService.fetchClientProfile(this.$route.params.id);
      this.loading = false;
    } catch (err) {
      console.log(err);
    }
  },

  computed: {
    fullName() {
      return (this.client)
        ? `${this.client.first_name} ${this.client.last_name}`
        : '';
    },

    items() {
      return [
        { text: 'Dashboard', to: '/' },
        { text: 'Clientes', to: '/clients' },
        { text: this.fullName, active: true },
      ];
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
